import React, { useRef, useState, useEffect, useCallback } from 'react'
import {
    View,
    TextInput,
    TouchableOpacity,
    TouchableWithoutFeedback,
    Keyboard,
    ActivityIndicator,
    Platform,
    Image,
    Text,
} from 'react-native'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import HeaderPosts from './HeaderPosts'
import InteractionsPosts from './InteractionsPosts'
import DescriptionPosts from './DescriptionPosts'
import MediaComponent from '../customUtils/Components/MediaComponent'
import { apiUrl } from '../../config/config'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import { FlatList } from 'react-native-gesture-handler'
import styles from './ItemDefaultStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import ModalComments from '../modals/ModalComments'
import StyledText from '../../../StyledText'
import ButtonCTA from './components/ButtonCTA'
import { openDB, getUser } from '../../db/indexDB'
import CommentInput from './components/CommentInput'
import { debug, info, warn, error, lazy } from '../../utils/logger'
import {
    SafeKeyboardAvoidingView,
    useSafeKeyboardOpen,
} from '../../../SafeKeyboardProvider'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useInteractionsStore } from '../../redux/zustand/interactionsPostStore'
import { isIOS } from '@/utils/platformUtils'
import { request_add_comment_wall } from '@/services/posts.services'
//import { PostsServices } from '../../../database/posts.database'

let PostsServices = null
// let BottomSheetFlashList;
if (Platform.OS !== 'web') {
    import('../../../database/posts.database').then(
        ({ PostsServices: NativePostsServices }) => {
            PostsServices = NativePostsServices
        },
    )
}

const COMMENTS_PAGE_SIZE = 10 // Mostrar 10 comentarios a la vez
const BACKEND_PAGE_SIZE = 20 // El backend devuelve 20 por página

export const PostWithComments = ({
    post,
    closeSheet,
    onPostUpdate,
    commentsOnly = false,
}) => {
    const { languageFile } = getLanguage()
    const isKeyboardOpen = useSafeKeyboardOpen()
    const insets = useSafeAreaInsets()

    // console.log('[PostWithComments] post._id:', post._id)
    // console.log('[PostWithComments] post.user_reaction:', post.user_reaction)
    // console.log('[PostWithComments] post.interactions:', post.interactions)

    // Estados de interacciones
    const [interactionPost, setInteractionPost] = useState({
        // Identificador del post para sincronizar con el feed
        post_id: post._id,
        // Contadores de comentarios
        comment_count:
            post.interactions?.comment_count ||
            post.interactions?.comments_counter ||
            0,
        comments_counter:
            post.interactions?.comments_counter ||
            post.interactions?.comment_count ||
            0,
        // Views visibles en Header
        views: post.interactions?.views ?? post.views ?? 0,
        // Reacciones y selección del usuario (se actualizan desde InteractionsPosts)
        reactions: Array.isArray(post.interactions?.reactions)
            ? post.interactions.reactions
            : [],
        user_reaction: Array.isArray(post.user_reaction)
            ? post.user_reaction
            : Array.isArray(post.interactions?.user_reaction)
              ? post.interactions.user_reaction
              : [],
        // Favorito (para mantener coherencia en el header del sidebar)
        favourite: post.interactions?.favourite ?? post.status_favourite,
    })
    // console.log('[PostWithComments] Initial comment count:', {
    //     comment_count: post.interactions?.comment_count,
    //     comments_counter: post.interactions?.comments_counter,
    //     final: interactionPost.comment_count
    // })
    const [tokenUser, setTokenUser] = useState('')
    const [currentUser, setCurrentUser] = useState(null)

    // Suscribirse al store global para este post y reflejar cambios (e.g., desde el feed)
    const interactionFromStore = useInteractionsStore(
        useCallback((state) => state.interactions?.[String(post?._id)], [post?._id]),
    )
    useEffect(() => {
        try {
            if (!interactionFromStore) return

            const storeCommentsCount = Math.max(
                interactionFromStore?.comments_counter || 0,
                interactionFromStore?.comment_count || 0,
            )

            if (
                storeCommentsCount > 0 &&
                storeCommentsCount !== commentsCountRef.current
            ) {
                setInitialCommentsCount(storeCommentsCount)
                commentsCountRef.current = storeCommentsCount
            }

            // Fusionar sólo campos relevantes si cambia la referencia/valores
            setInteractionPost((prev) => {
                const next = { ...prev, ...interactionFromStore, post_id: post._id }

                const prevComments = Math.max(
                    prev.comments_counter || 0,
                    prev.comment_count || 0,
                )
                const nextComments = Math.max(
                    next.comments_counter || 0,
                    next.comment_count || 0,
                )

                if (prevComments !== nextComments) {
                    return next
                }

                const prevStr = JSON.stringify({
                    reactions: prev.reactions,
                    user_reaction: prev.user_reaction,
                    favourite: prev.favourite,
                })
                const nextStr = JSON.stringify({
                    reactions: next.reactions,
                    user_reaction: next.user_reaction,
                    favourite: next.favourite,
                })
                if (prevStr !== nextStr) {
                    debug('Reactions', '[PostWithComments] Sync from store')
                    return next
                }
                return prev
            })
        } catch {}
    }, [interactionFromStore])

    // Estados de comentarios
    const [text, setText] = useState('')
    const [commentId, setCommentId] = useState()
    const [userToSend, setUserToSend] = useState()
    const inputRef = useRef(null)

    const [allComments, setAllComments] = useState([]) // Todos los comentarios cargados del backend
    const [displayedComments, setDisplayedComments] = useState([]) // Los comentarios mostrados actualmente (de 10 en 10)
    const [loading, setLoading] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const [viewLoading, setViewLoading] = useState(true)
    const [page, setPage] = useState(0) // Página para el backend
    const [hasMore, setHasMore] = useState(true) // Si hay más comentarios para cargar del backend

    const flatListRef = useRef(null)

    // Catálogo autorizado de reacciones (single.reactions) para construir modal y UI en sidebar
    const [reactionDefs, setReactionDefs] = useState([])
    // Estado y refs para el selector de reacciones (igual que en feed)
    const [showReactionPicker, setShowReactionPicker] = useState(false)
    const handleLikeClickRef = useRef(null)
    const [replies_response, setRepliesResponse] = useState([])

    const [initialCommentsCount, setInitialCommentsCount] = useState(() => {
        return Math.max(
            post.interactions?.comments_counter || 0,
            post.interactions?.comment_count || 0,
        )
    })
    const commentsCountRef = useRef(initialCommentsCount)
    const allCommentsRef = useRef(null)

    useEffect(() => {
        allCommentsRef.current = allComments.filter((i) => !i._id.startsWith('temp'))
    }, [allComments])

    useEffect(() => {
        fetchToken()
        fetchCurrentUser()
        fetchComments(0).finally(() => {
            setViewLoading(false)
        })
        // Cargar catálogo de reacciones desde caché web, fallback a global/window o DB local
        try {
            const webSrv = require('../../services/web/postsWebService')
            const defs = webSrv.getCachedReactions?.() || []
            debug(
                'Reactions',
                '[PostWithComments] getCachedReactions len',
                Array.isArray(defs) ? defs.length : 0,
            )
            if (Array.isArray(defs) && defs.length > 0) {
                setReactionDefs(defs)
            } else {
                // Fallback rápido: catálogo global en memoria si existe
                if (
                    typeof window !== 'undefined' &&
                    Array.isArray(window.__globalReactions) &&
                    window.__globalReactions.length > 0
                ) {
                    setReactionDefs(window.__globalReactions)
                    debug(
                        'Reactions',
                        '[PostWithComments] Using __globalReactions fallback',
                        window.__globalReactions.length,
                    )
                } else {
                    // Fallback: intentar desde IndexedDB
                    ;(async () => {
                        try {
                            const db = await openDB()
                            let defsDb = []
                            try {
                                const idx = require('../../db/indexDB')
                                if (typeof idx.getAllReactions === 'function') {
                                    defsDb = await idx.getAllReactions(db)
                                }
                            } catch {}
                            debug(
                                'Reactions',
                                '[PostWithComments] getAllReactions (DB) len',
                                Array.isArray(defsDb) ? defsDb.length : 0,
                            )
                            setReactionDefs(Array.isArray(defsDb) ? defsDb : [])
                        } catch (e) {
                            warn(
                                'Reactions',
                                '[PostWithComments] Unable to load reaction defs from DB',
                                e?.message,
                            )
                        }
                    })()
                }
            }
        } catch (e) {
            warn(
                'Reactions',
                '[PostWithComments] postsWebService not available',
                e?.message,
            )
        }

        // Fix para web: Forzar el input al bottom del sidebar
        if (Platform.OS === 'web') {
            setTimeout(() => {
                const inputContainer = document.getElementById(
                    'comment-input-container',
                )
                if (inputContainer) {
                    inputContainer.style.position = 'sticky'
                    inputContainer.style.bottom = '0'
                    inputContainer.style.zIndex = '1000'
                    debug(
                        'Comments',
                        '[PostWithComments] Applied sticky position to input',
                    )
                }
            }, 100)
        }
    }, [])

    const fetchToken = async () => {
        try {
            const authToken = await getAuthToken()
            if (authToken) setTokenUser(authToken)
        } catch (error) {
            error('Auth', 'Error fetching token', error)
        }
    }

    const fetchCurrentUser = async () => {
        try {
            let user = null
            if (Platform.OS === 'web') {
                const database = await openDB()
                user = await getUser(database)
            } else {
                user = await PostsServices.getUser()
            }
            console.log('[PostWithComments] Current user fetched:', user)
            if (user) {
                setCurrentUser(user)
                debug('Auth', '[PostWithComments] Current user loaded', user.name)
                return user
            } else {
                return null
            }
        } catch (error) {
            error('Auth', '[PostWithComments] Error fetching current user', error)
            return null
        }
    }

    const fetchComments = async (pageNum) => {
        debug('Comments', '[PostWithComments] fetchComments called', {
            pageNum,
            hasMore,
            allCommentsCount: allComments.length,
        })
        if (!hasMore && pageNum > 0) {
            debug(
                'Comments',
                '[PostWithComments] No more comments to fetch from backend',
            )
            return
        }

        try {
            pageNum === 0 ? setLoading(true) : setLoadingMore(true)

            const authToken = await getAuthToken()
            if (!authToken) {
                debug(
                    'Comments',
                    '[PostWithComments] No auth token available, skipping fetch',
                )
                setHasMore(false)
                return
            }

            debug(
                'Comments',
                '[PostWithComments] Fetching from backend - page',
                pageNum,
            )

            const response = await fetch(`${apiUrl}/get_comment_wall`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                    post_id: post._id,
                    page: pageNum.toString(),
                },
            })

            const data = await response.json()
            debug('Comments', '[PostWithComments] Backend response', {
                status: data.status,
                commentsCount: data.single?.comments?.length,
                hasComments:
                    Array.isArray(data.single?.comments) &&
                    data.single.comments.length > 0,
            })

            const newComments = Array.isArray(data.single?.comments)
                ? data.single.comments
                : []
            if (data.status === 1 && newComments.length > 0) {
                debug(
                    'Comments',
                    '[PostWithComments] Received comments',
                    newComments.length,
                )

                // El backend devuelve 20 comentarios por página
                // Agregamos todos al cache y mostramos los primeros 10
                if (pageNum === 0) {
                    setAllComments(newComments)
                    setDisplayedComments(newComments.slice(0, COMMENTS_PAGE_SIZE))
                } else {
                    setAllComments((prev) => [...prev, ...newComments])
                    // No mostramos más aquí, el botón "Ver más" se encargará
                }

                setPage(pageNum)
                // Si recibimos menos de 20, no hay más en el backend
                setHasMore(newComments.length >= BACKEND_PAGE_SIZE)
                debug(
                    'Comments',
                    '[PostWithComments] hasMore set to',
                    newComments.length >= BACKEND_PAGE_SIZE,
                )
            } else {
                debug('Comments', '[PostWithComments] No more comments from backend')
                setHasMore(false)
            }
        } catch (error) {
            error('Comments', '[PostWithComments] Error fetching comments', error)
            setHasMore(false)
        } finally {
            setLoading(false)
            setLoadingMore(false)
        }
    }

    const handleLoadMore = () => {
        debug('Comments', '[PostWithComments] handleLoadMore called', {
            displayedCount: displayedComments.length,
            allCommentsCount: allComments.length,
            loadingMore,
            hasMore,
        })

        if (loadingMore) {
            debug('Comments', '[PostWithComments] Already loading, skipping')
            return
        }

        setLoadingMore(true)

        try {
            // Primero verificamos si tenemos más comentarios en cache
            const nextComments = allComments.slice(
                displayedComments.length,
                displayedComments.length + COMMENTS_PAGE_SIZE,
            )

            debug(
                'Comments',
                '[PostWithComments] Next comments from cache',
                nextComments.length,
            )

            if (nextComments.length > 0) {
                // Tenemos comentarios en cache, los mostramos
                debug(
                    'Comments',
                    '[PostWithComments] Showing next comments from cache',
                    nextComments.length,
                )
                setDisplayedComments((prev) => [...prev, ...nextComments])

                // Si mostramos menos de 10 y hay más en el backend, fetch
                if (nextComments.length < COMMENTS_PAGE_SIZE && hasMore) {
                    debug(
                        'Comments',
                        '[PostWithComments] Cache running low, fetching more from backend',
                    )
                    fetchComments(page + 1)
                }
            } else if (hasMore) {
                // No hay en cache pero hay más en el backend
                debug(
                    'Comments',
                    '[PostWithComments] No cache, fetching from backend',
                )
                fetchComments(page + 1)
            } else {
                debug('Comments', '[PostWithComments] No more comments available')
            }
        } catch (error) {
            error('Comments', '[PostWithComments] Error in handleLoadMore', error)
        } finally {
            setTimeout(() => {
                setLoadingMore(false)
            }, 500)
        }
    }

    const handleTextChange = useCallback((newText) => {
        setText(newText)
    }, [])

    const handleTextChangeReply = useCallback((name_user, comment_id) => {
        if (comment_id) {
            setUserToSend(name_user)
            setText(name_user)
            setCommentId(comment_id)
        } else {
            setUserToSend()
            setText('')
            setCommentId()
            Keyboard.dismiss()
        }
    }, [])

    const handleClearReply = useCallback(() => {
        setUserToSend()
        setText('')
        setCommentId()
        Keyboard.dismiss()
    }, [])

    const setInteractions = useInteractionsStore((state) => state.setInteractions)

    const handleSendComment = useCallback(
        async (textValue) => {
            if (!textValue || textValue.trim() === '') return
            if (!currentUser) {
                let newUser = await fetchCurrentUser()
                if (!newUser) {
                    error('Comments', '[PostWithComments] No current user available')
                    return
                }
            }
            let idComment = commentId
            if (!textValue.startsWith('@')) {
                idComment = undefined
            }

            const lastCommentID =
                allCommentsRef.current.length > 0
                    ? allCommentsRef.current.reduce((a, b) =>
                          b.created_date > a.created_date ? b : a,
                      )._id
                    : null

            // Crear comentario optimista
            const optimisticComment = {
                _id: `temp_${Date.now()}`, // ID temporal
                name: currentUser.name || 'Usuario',
                comment: textValue,
                avatar_image: currentUser.avatar || '',
                created_date: new Date().toISOString(),
                likes_count: 0,
                replies_counter: 0,
                isSelected: false,
                isOptimistic: true, // Marcar como optimista
                comment_id: idComment || null,
            }

            try {
                const currentRealCount = commentsCountRef.current
                const newCount = currentRealCount + 1

                commentsCountRef.current = newCount

                // Inyectar el comentario al inicio inmediatamente
                if (!idComment) {
                    setAllComments((prev) => [optimisticComment, ...prev])
                    setDisplayedComments((prev) => [optimisticComment, ...prev])
                } else {
                    setRepliesResponse((prev) => [optimisticComment, ...prev])
                }

                setInitialCommentsCount(newCount)

                setInteractions({
                    [String(post._id)]: {
                        ...interactionFromStore,
                        post_id: String(post._id),
                        comments_counter: newCount,
                        comment_count: newCount,
                        reactions:
                            interactionFromStore?.reactions ||
                            interactionPost.reactions ||
                            [],
                        user_reaction:
                            interactionFromStore?.user_reaction ||
                            interactionPost.user_reaction ||
                            [],
                        views:
                            interactionFromStore?.views ||
                            interactionPost.views ||
                            0,
                        favourite:
                            interactionFromStore?.favourite ??
                            interactionPost.favourite,
                    },
                })

                setInteractionPost((prev) => ({
                    ...prev,
                    comments_counter: newCount,
                    comment_count: newCount, // ItemDefault usa este campo
                }))

                // Notificar al post padre del cambio (enviar ambos campos)
                if (onPostUpdate) {
                    debug(
                        'Comments',
                        '[PostWithComments] Calling onPostUpdate with:',
                        {
                            comments_counter: newCount,
                            comment_count: newCount,
                        },
                    )
                    onPostUpdate({
                        comments_counter: newCount,
                        comment_count: newCount, // ItemDefault usa este campo
                    })
                }

                // Limpiar input
                setText('')
                setCommentId()
                setUserToSend()
                Keyboard.dismiss()

                const authToken = await getAuthToken()
                if (!authToken) return
                console.log('LASTCOMMENT ==>, ', lastCommentID)
                const data = await request_add_comment_wall({
                    authToken,
                    post_id: post._id,
                    parent_comment_id: idComment,
                    message: textValue,
                    last_comment_id: lastCommentID,
                })
                console.log('DATA COMMENT ==>', JSON.stringify(data))
                if (data.status === 1) {
                    // Reemplazar el comentario optimista con el real
                    const newComments = data.single?.users_comments

                    if (newComments?.length > 0) {
                        // Actualizar con datos reales del backend

                        //TODO Actualizar comentarios con el array nuevo y quitar el temporal

                        if (idComment) {
                            // Si es reply, actualiza replies_response
                            setRepliesResponse((prev) => {
                                const commentsWithoutTemporal = prev.filter(
                                    (t) => !t._id.startsWith('temp'),
                                )
                                const existingIds = new Set(
                                    commentsWithoutTemporal.map((comment) =>
                                        comment._id.toString(),
                                    ),
                                )
                                const uniqueNewComments = newComments.filter(
                                    (comment) =>
                                        comment?._id &&
                                        !existingIds.has(comment._id.toString()),
                                )
                                //comment_id : comment_id
                                if (uniqueNewComments.length > 0) {
                                    uniqueNewComments[0].comment_id = commentId
                                }
                                return [
                                    ...uniqueNewComments,
                                    ...commentsWithoutTemporal,
                                ]
                            })
                        } else {
                            // Si es comentario raíz, actualiza los comentarios principales
                            setAllComments((prev) => {
                                const commentsWithoutTemporal = prev.filter(
                                    (t) => !t._id.startsWith('temp'),
                                )

                                const existingIds = new Set(
                                    commentsWithoutTemporal.map((comment) =>
                                        comment._id.toString(),
                                    ),
                                )

                                const uniqueNewComments = newComments.filter(
                                    (comment) =>
                                        comment?._id &&
                                        !existingIds.has(comment._id.toString()),
                                )

                                return [
                                    ...uniqueNewComments,
                                    ...commentsWithoutTemporal,
                                ]
                            })

                            setDisplayedComments((prev) => {
                                const commentsWithoutTemporal = prev.filter(
                                    (t) => !t._id.startsWith('temp'),
                                )

                                const existingIds = new Set(
                                    commentsWithoutTemporal.map((comment) =>
                                        comment._id.toString(),
                                    ),
                                )

                                const uniqueNewComments = newComments.filter(
                                    (comment) =>
                                        comment?._id &&
                                        !existingIds.has(comment._id.toString()),
                                )

                                return [
                                    ...uniqueNewComments,
                                    ...commentsWithoutTemporal,
                                ]
                            })
                        }
                        info(
                            'Comments',
                            '[PostWithComments] Comment posted successfully, replaced optimistic with real',
                        )
                    } else {
                        // Si no viene el comentario, lo dejamos como está pero removemos la marca optimista
                        if (idComment) {
                            // Si es reply, actualiza replies_response
                            setRepliesResponse((prev) =>
                                prev.map((c) =>
                                    c._id === optimisticComment._id
                                        ? { ...c, isOptimistic: false }
                                        : c,
                                ),
                            )
                        } else {
                            setAllComments((prev) =>
                                prev.map((c) =>
                                    c._id === optimisticComment._id
                                        ? { ...c, isOptimistic: false }
                                        : c,
                                ),
                            )
                            setDisplayedComments((prev) =>
                                prev.map((c) =>
                                    c._id === optimisticComment._id
                                        ? { ...c, isOptimistic: false }
                                        : c,
                                ),
                            )
                        }
                        warn(
                            'Comments',
                            '[PostWithComments] Comment posted, no real comment returned',
                        )
                    }
                } else {
                    // Si falla, remover el comentario optimista
                    error('Comments', '[PostWithComments] Failed to post comment:', {
                        status: data.status,
                        message: data.message,
                        responseStatus: response.status,
                    })
                    setRepliesResponse((prev) =>
                        prev.filter((c) => c._id !== optimisticComment._id),
                    )
                    setAllComments((prev) =>
                        prev.filter((c) => c._id !== optimisticComment._id),
                    )
                    setDisplayedComments((prev) =>
                        prev.filter((c) => c._id !== optimisticComment._id),
                    )
                    const newCounter = Math.max(
                        0,
                        (interactionPost.comments_counter ||
                            interactionPost.comment_count ||
                            0) - 1,
                    )
                    setInteractionPost((prev) => ({
                        ...prev,
                        comments_counter: newCounter,
                        comment_count: newCounter,
                    }))
                    if (onPostUpdate) {
                        onPostUpdate({
                            comments_counter: newCounter,
                            comment_count: newCounter,
                        })
                    }

                    // Aquí podrías mostrar un mensaje al usuario
                    // Alert.alert('Error', 'No se pudo enviar el comentario')
                }
            } catch (err) {
                error('Comments', '[PostWithComments] Error sending comment:', {
                    error: err.message,
                    stack: err.stack,
                    name: err.name,
                })
                // Remover comentario optimista en caso de error
                setAllComments((prev) =>
                    prev.filter((c) => c._id !== optimisticComment._id),
                )
                setDisplayedComments((prev) =>
                    prev.filter((c) => c._id !== optimisticComment._id),
                )
                const newCounter = Math.max(
                    0,
                    (interactionPost.comments_counter ||
                        interactionPost.comment_count ||
                        0) - 1,
                )
                setInteractionPost((prev) => ({
                    ...prev,
                    comments_counter: newCounter,
                    comment_count: newCounter,
                }))
                if (onPostUpdate) {
                    onPostUpdate({
                        comments_counter: newCounter,
                        comment_count: newCounter,
                    })
                }

                // Aquí podrías mostrar un mensaje al usuario
                // Alert.alert('Error', 'Error de conexión al enviar comentario')
            }
        },
        [
            post._id,
            commentId,
            currentUser,
            onPostUpdate,
            setInteractions,
            interactionFromStore,
        ],
    )

    const handleSendCommentLikes = useCallback(
        async (comment_id, father_id) => {
            // Evitar toggles concurrentes sobre el mismo comentario
            const pendingRef =
                handleSendCommentLikes.__pending ||
                (handleSendCommentLikes.__pending = new Set())
            if (pendingRef.has(String(comment_id))) {
                return null
            }
            pendingRef.add(String(comment_id))

            // Si es comentario raíz (no reply), aplicar optimismo inmediato en el listado visible y cache completa
            let rollbackInfo = null
            let isFirstComment = false
            if (!father_id) {
                try {
                    let prevComment = null
                    setDisplayedComments((prev) => {
                        const next = prev.map((c, index) => {
                            if (c._id === comment_id) {
                                // Verifico si es el primer comentario
                                if (index === 0) {
                                    isFirstComment = true
                                }
                                const prevLikes = Number(c.likes_count) || 0
                                const prevSel = !!c.isSelected
                                const nextSel = !prevSel
                                const nextLikes = Math.max(
                                    0,
                                    prevLikes + (nextSel ? 1 : -1),
                                )
                                prevComment = {
                                    _id: c._id,
                                    likes_count: prevLikes,
                                    isSelected: prevSel,
                                }
                                return {
                                    ...c,
                                    likes_count: nextLikes,
                                    isSelected: nextSel,
                                }
                            }
                            return c
                        })
                        return next
                    })
                    // Mantener coherencia con cache completa
                    setAllComments((prev) =>
                        prev.map((c) => {
                            if (c._id === comment_id && prevComment) {
                                const nextSel = !prevComment.isSelected
                                const nextLikes = Math.max(
                                    0,
                                    (Number(prevComment.likes_count) || 0) +
                                        (nextSel ? 1 : -1),
                                )
                                return {
                                    ...c,
                                    likes_count: nextLikes,
                                    isSelected: nextSel,
                                }
                            }
                            return c
                        }),
                    )
                    rollbackInfo = prevComment
                } catch (e) {
                    // noop optimismo si falla lectura previa
                }
            }

            try {
                const authToken = await getAuthToken()
                if (!authToken) throw new Error('No auth token')

                const body = {
                    comment_id: comment_id,
                    father_id: father_id,
                }

                let headers = {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                    comment_id: comment_id,
                    post_id: post._id,
                }

                const response = await fetch(`${apiUrl}/add_like_comment`, {
                    method: 'POST',
                    headers: headers,
                    // body: JSON.stringify(body),
                })

                const data = await response.json()
                // Si es comentario raíz, reconciliar con respuesta del backend
                if (!father_id) {
                    if (data && data.status === 1) {
                        const dataResponse = data.single || {}
                        const serverLikes = Number(dataResponse?.counter) || 0
                        const serverSel =
                            dataResponse?.status_like === 1 ? true : false
                        setDisplayedComments((prev) =>
                            prev.map((c) =>
                                c._id === comment_id
                                    ? {
                                          ...c,
                                          likes_count: serverLikes,
                                          isSelected: serverSel,
                                      }
                                    : c,
                            ),
                        )
                        setAllComments((prev) =>
                            prev.map((c) =>
                                c._id === comment_id
                                    ? {
                                          ...c,
                                          likes_count: serverLikes,
                                          isSelected: serverSel,
                                      }
                                    : c,
                            ),
                        )

                        // Si es el primer comentario, actualizar el store global para sincronizar con CommentsPosts
                        if (isFirstComment && interactionFromStore) {
                            const updatedFirstComment = {
                                ...interactionFromStore.comment_first,
                                likes_count: serverLikes,
                                isSelected: serverSel,
                            }
                            setInteractions({
                                [String(post._id)]: {
                                    ...interactionFromStore,
                                    comment_first: updatedFirstComment,
                                },
                            })
                        }
                    } else if (rollbackInfo) {
                        // Revertir si falla
                        setDisplayedComments((prev) =>
                            prev.map((c) =>
                                c._id === comment_id
                                    ? {
                                          ...c,
                                          likes_count: rollbackInfo.likes_count,
                                          isSelected: rollbackInfo.isSelected,
                                      }
                                    : c,
                            ),
                        )
                        setAllComments((prev) =>
                            prev.map((c) =>
                                c._id === comment_id
                                    ? {
                                          ...c,
                                          likes_count: rollbackInfo.likes_count,
                                          isSelected: rollbackInfo.isSelected,
                                      }
                                    : c,
                            ),
                        )

                        // Si es el primer comentario, revertir también en el store global
                        if (isFirstComment && interactionFromStore) {
                            const revertedFirstComment = {
                                ...interactionFromStore.comment_first,
                                likes_count: rollbackInfo.likes_count,
                                isSelected: rollbackInfo.isSelected,
                            }
                            setInteractions({
                                [String(post._id)]: {
                                    ...interactionFromStore,
                                    comment_first: revertedFirstComment,
                                },
                            })
                        }
                    }
                }

                return data
            } catch (err) {
                error('Comments', 'Error liking comment:', err)
                // Revertir optimismo si corresponde
                if (!father_id && rollbackInfo) {
                    setDisplayedComments((prev) =>
                        prev.map((c) =>
                            c._id === comment_id
                                ? {
                                      ...c,
                                      likes_count: rollbackInfo.likes_count,
                                      isSelected: rollbackInfo.isSelected,
                                  }
                                : c,
                        ),
                    )
                    setAllComments((prev) =>
                        prev.map((c) =>
                            c._id === comment_id
                                ? {
                                      ...c,
                                      likes_count: rollbackInfo.likes_count,
                                      isSelected: rollbackInfo.isSelected,
                                  }
                                : c,
                        ),
                    )

                    // Si es el primer comentario, revertir también en el store global
                    if (isFirstComment && interactionFromStore) {
                        const revertedFirstComment = {
                            ...interactionFromStore.comment_first,
                            likes_count: rollbackInfo.likes_count,
                            isSelected: rollbackInfo.isSelected,
                        }
                        setInteractions({
                            [String(post._id)]: {
                                ...interactionFromStore,
                                comment_first: revertedFirstComment,
                            },
                        })
                    }
                }
                return null
            } finally {
                pendingRef.delete(String(comment_id))
            }
        },
        [setDisplayedComments, setAllComments],
    )

    const handleTextandCloseChange = async (newText) => {
        await handleSendComment(newText)
    }

    const renderFooter = () => {
        const hasMoreInCache = displayedComments.length < allComments.length
        const canLoadMore = hasMoreInCache || hasMore

        // console.log('[PostWithComments] renderFooter', {
        //     loading,
        //     page,
        //     hasMore,
        //     displayedCount: displayedComments.length,
        //     allCommentsCount: allComments.length,
        //     hasMoreInCache,
        //     canLoadMore,
        //     loadingMore
        // })

        if (loading && page === 0) {
            return (
                <View style={{ padding: 20, alignItems: 'center' }}>
                    <ActivityIndicator
                        size='small'
                        color={theme.colors.colorPrimary}
                    />
                </View>
            )
        }

        if (canLoadMore && displayedComments.length > 0) {
            // console.log('[PostWithComments] Showing "Ver más" button')
            return (
                <TouchableOpacity
                    onPress={handleLoadMore}
                    disabled={loadingMore}
                    style={{
                        padding: 16,
                        marginVertical: 8,
                        marginHorizontal: 12,
                        alignItems: 'center',
                        borderRadius: 8,
                    }}
                >
                    {loadingMore ? (
                        <ActivityIndicator
                            size='small'
                            color={theme.colors.colorPrimary}
                        />
                    ) : (
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <StyledText
                                fontSize='smallText'
                                fontWeight='bold'
                                color={theme.colors.textSecondary}
                            >
                                {languageFile.load_more || 'Ver más comentarios'}
                            </StyledText>
                            <Feather
                                name='chevron-down'
                                size={20}
                                color={theme.colors.colorPrimary}
                                style={{ marginLeft: 8 }}
                            />
                        </View>
                    )}
                </TouchableOpacity>
            )
        }

        return null
    }

    const renderHeader = () => {
        try {
            // En modo commentsOnly en mobile, no renderizamos media, descripción ni interacciones
            if (commentsOnly && Platform.OS !== 'web') {
                return (
                    <View style={[styles.commentsHeader]}>
                        <StyledText fontSize='normalText' fontWeight='bold'>
                            {languageFile.comments || 'Comentarios'}
                        </StyledText>
                    </View>
                )
            }

            return (
                <View>
                    {/* Post Header */}
                    <HeaderPosts
                        avatar={post.avatar}
                        publisher={post.publisher}
                        labels={post.labels}
                        date={post.publication_date}
                        views={interactionPost?.views ?? post?.views ?? '0'}
                    />

                    {/* Post Media con overlay de reacciones (como en feed) */}
                    {post.medias && post.medias.length > 0 && (
                        <View style={{ position: 'relative' }}>
                            <MediaComponent
                                medias={post.medias}
                                onPageChange={() => {}}
                                onEndReached={() => {}}
                                contentSeen={() => {}}
                                isPostPlayer={true}
                                isPost={true}
                            />

                            {/* Selector de reacciones sobre el media (solo web) */}
                            {Platform.OS === 'web' && showReactionPicker && (
                                <View
                                    style={{
                                        position: 'absolute',
                                        bottom: 20,
                                        left: 0,
                                        right: 0,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 9999,
                                        pointerEvents: 'box-none',
                                    }}
                                    onMouseLeave={() => {
                                        setShowReactionPicker(false)
                                    }}
                                >
                                    <View
                                        style={{
                                            backgroundColor:
                                                'rgba(255, 255, 255, 0.98)',
                                            borderRadius: 50,
                                            paddingHorizontal: 16,
                                            paddingVertical: 10,
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            gap: 8,
                                            shadowColor: '#000',
                                            shadowOffset: { width: 0, height: 4 },
                                            shadowOpacity: 0.3,
                                            shadowRadius: 12,
                                            elevation: 8,
                                            pointerEvents: 'auto',
                                        }}
                                    >
                                        {(() => {
                                            const {
                                                getReactionAsset,
                                            } = require('./utils/reactionAssets')

                                            const merged = (
                                                Array.isArray(reactionDefs)
                                                    ? reactionDefs
                                                    : []
                                            ).map((def) => {
                                                const match = (
                                                    interactionPost?.reactions || []
                                                ).find((r) => {
                                                    const rid =
                                                        r?.reaction_id || r?._id
                                                    return (
                                                        rid?.toString?.() ===
                                                        def?._id?.toString?.()
                                                    )
                                                })
                                                return {
                                                    ...def,
                                                    count: Number(match?.count) || 0,
                                                }
                                            })

                                            const onPress = (id) => {
                                                if (handleLikeClickRef.current) {
                                                    handleLikeClickRef.current(id)
                                                    setShowReactionPicker(false)
                                                }
                                            }

                                            return merged.map((reaction, idx) => (
                                                <TouchableOpacity
                                                    key={reaction._id || idx}
                                                    onPress={() =>
                                                        onPress(reaction._id)
                                                    }
                                                    style={{
                                                        alignItems: 'center',
                                                        paddingVertical: 6,
                                                        paddingHorizontal: 8,
                                                        borderRadius: 8,
                                                    }}
                                                >
                                                    <Image
                                                        source={getReactionAsset(
                                                            reaction.name,
                                                        )}
                                                        style={{
                                                            width: 38,
                                                            height: 38,
                                                        }}
                                                    />
                                                    <StyledText
                                                        fontSize='tinyText'
                                                        color='#666'
                                                        style={{ marginTop: 4 }}
                                                    >
                                                        {reaction.count || 0}
                                                    </StyledText>
                                                </TouchableOpacity>
                                            ))
                                        })()}
                                    </View>
                                </View>
                            )}
                        </View>
                    )}

                    {/* Post Description */}
                    {post.description && post.description !== '' && (
                        <DescriptionPosts
                            description={post.description}
                            publisher={post.publisher}
                            tagUsers={post.tag_users || []}
                        />
                    )}

                    {/* CTA Button (nuevo cta_button) o fallback legacy (text_link_share/link_share) */}
                    {/* {(() => {
                        const hasNewCTA = !!post?.cta_button
                        const hasLegacyCTA = !!post?.text_link_share || !!post?.link_share
                        // Log liviano para depuración (se puede remover luego)
                        debug('CTA', '[PostWithComments] render CTA', {
                            postId: post?._id,
                            hasNewCTA,
                            hasLegacyCTA,
                            text: post?.cta_button?.text || post?.text_link_share,
                        })
                        if (hasNewCTA) {
                            return (
                                <ButtonCTA
                                    posts={post}
                                    url={post.cta_button.url}
                                    text={post.cta_button.text}
                                    style_type={post.cta_button.style_type}
                                />
                            )
                        }
                        if (hasLegacyCTA) {
                            // Pasamos solo posts para que ButtonCTA resuelva label & link legacy
                            return <ButtonCTA posts={post} />
                        }
                        return null
                    })()} */}

                    {/* Post Interactions */}
                    {/* Pasamos el catálogo autorizado (defs) y propagamos updates al padre */}
                    <InteractionsPosts
                        posts={post}
                        onCommentClick={() => inputRef.current?.focus()}
                        comments_counter={interactionPost.comments_counter || 0}
                        reactions={reactionDefs}
                        favourite={interactionPost.favourite}
                        interactions={interactionPost}
                        user_reaction={post.user_reaction}
                        isGoTo={false}
                        updateInteractions={(newInteractions) => {
                            debug(
                                'Reactions',
                                '[PostWithComments] updateInteractions from InteractionsPosts',
                            )
                            // Actualizar estado local
                            setInteractionPost(newInteractions)
                            // Notificar al padre (para que el feed pueda mergear)
                            if (onPostUpdate) {
                                onPostUpdate({
                                    post_id: post._id,
                                    reactions: newInteractions.reactions,
                                    user_reaction: newInteractions.user_reaction,
                                    favourite: newInteractions.favourite,
                                    views: newInteractions.views,
                                    comments_counter:
                                        newInteractions.comments_counter,
                                    comment_count: newInteractions.comment_count,
                                })
                            }
                        }}
                        onReactionPickerRef={handleLikeClickRef}
                        showReactionPicker={showReactionPicker}
                        setShowReactionPicker={setShowReactionPicker}
                    />

                    {/* Comments Header */}
                    {Platform.OS === 'web' ? (
                        <View style={{ height: 10 }} />
                    ) : (
                        <View style={styles.commentsHeader}>
                            <StyledText fontSize='mediumText' fontWeight='bold'>
                                {languageFile.comments || 'Comentarios'}
                            </StyledText>
                        </View>
                    )}
                </View>
            )
        } catch (error) {
            error('Posts', '[PostWithComments] Error rendering header:', error)
            return (
                <View style={{ padding: 20 }}>
                    <StyledText>Error al cargar el post</StyledText>
                </View>
            )
        }
    }

    return (
        <SafeKeyboardAvoidingView
            behavior='padding'
            style={{
                flex: 1,
                backgroundColor: theme.colors.background,
                ...(Platform.OS === 'web' && {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    maxHeight: '100%',
                    overflow: 'hidden',
                }),
            }}
        >
            {viewLoading ? (
                <View
                    style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <ActivityIndicator
                        size='large'
                        color={theme.colors.colorPrimary}
                    />
                </View>
            ) : (
                <>
                    {displayedComments.length > 0 ? (
                        <View style={{ flex: 1, width: '100%' }}>
                            {/* FlatList optimizada para videos */}
                            <FlatList
                                ref={flatListRef}
                                data={displayedComments}
                                keyExtractor={(item, index) =>
                                    item._id || index.toString()
                                }
                                renderItem={({ item, index }) => (
                                    <ModalComments
                                        comment={item}
                                        onReply={handleTextChangeReply}
                                        handleLike={handleSendCommentLikes}
                                        inputRef={inputRef}
                                        replies_response={replies_response}
                                        comment_id={null}
                                        isVisible={true} // Si tienes lógica de visibilidad, pásala aquí
                                    />
                                )}
                                // ListEmptyComponent={
                                //     !loading && (
                                //         <View style={{ padding: 20, alignItems: 'center' }}>
                                //             <StyledText fontSize='smallText' color='gray'>
                                //                 {languageFile.no_comments || 'No hay comentarios aún'}
                                //             </StyledText>
                                //         </View>
                                //     )
                                // }
                                showsVerticalScrollIndicator={true}
                                keyboardShouldPersistTaps='handled'
                                keyboardDismissMode='on-drag'
                                style={{
                                    ...(Platform.OS === 'web' && {
                                        flexGrow: 1,
                                        flexShrink: 1,
                                        minHeight: 0,
                                    }),
                                }}
                                enableFooterMarginAdjustment={true}
                                ListHeaderComponent={renderHeader}
                                ListFooterComponent={renderFooter}
                                nestedScrollEnabled
                                removeClippedSubviews={true}
                                windowSize={7}
                                initialNumToRender={5}
                                // onViewableItemsChanged={({ viewableItems }) => {
                                //     // Aquí podrías actualizar el estado de visibilidad para videos si lo necesitas
                                // }}
                            />
                        </View>
                    ) : (
                        <TouchableWithoutFeedback
                            onPress={Keyboard.dismiss}
                            accessible={false}
                        >
                            <View style={styles.containerNoComments}>
                                <Image
                                    style={styles.imageNoComments}
                                    source={require('../../../assets/noComments.png')}
                                />
                                <Text style={styles.titleNoComments}>
                                    {languageFile.first_comment}
                                </Text>
                                <Text style={styles.descriptionNoComments}>
                                    {languageFile.no_comment}
                                </Text>
                            </View>
                        </TouchableWithoutFeedback>
                    )}
                </>
            )}
            {/* Input de comentarios - Footer fijo */}
            <View
                style={{
                    bottom: 0,
                    width: '100%',
                    backgroundColor: 'white',
                    marginBottom: isKeyboardOpen
                        ? isIOS()
                            ? -(insets.bottom - 20)
                            : 4
                        : 0,
                }}
            >
                <CommentInput
                    userToSend={userToSend}
                    loading={loading}
                    onSend={handleTextandCloseChange}
                    onClearReply={handleClearReply}
                    inputRef={inputRef}
                    placeholder={
                        userToSend
                            ? languageFile.reply_to || `Responder a ${userToSend}`
                            : languageFile.add_comment || 'Añadir un comentario...'
                    }
                />
            </View>
        </SafeKeyboardAvoidingView>
    )
}

export default PostWithComments
